import {
  Box,
  Typography,
  Button,
} from "@mui/material"
import { useToastMessageQueue } from "components/ToastMessages/ToastMessageProvider"

type DialogShowcaseProps = {
    size: "small" | "medium"
}

const ToastShowcase: React.FC<DialogShowcaseProps> = ({size}) => {
  const { info, warning, success, error } = useToastMessageQueue();
  
  const successDialog = () => {
    success({
      message: "This is a success dialog",
      header: "Success",
    })
  }

  const infoDialog = () => {
    info({
      message: "This is an info dialog",
      header: "Info",
    })
  }

  const errorDialog = () => {
    error({
      message: "This is an error dialog",
      header: "Error",
    })
  }

  const warningDialog = () => {
    warning({
      message: "This is a warning dialog",
      header: "Warning",
    })
  }

  return (<>
    <Typography className="text-xl font-bold">Toasts</Typography>
    <Box display={"flex"} flexDirection={"row"} gap={2}>
        <Button variant="contained" color="info" size={size} onClick={infoDialog}>
          Toast Info
        </Button>
        <Button variant="contained" color="success" size={size} onClick={successDialog}>
          Toast Success
        </Button>
        <Button variant="contained" color="error" size={size} onClick={errorDialog}>
          Toast Error
        </Button>
        <Button variant="contained" color="warning" size={size} onClick={warningDialog}>
          Toast Warning
        </Button>
    </Box>
  </>)
}

export default ToastShowcase
